export default {
  reset_password: "Redefinição de senha",
  info_email: "Informe o e-mail vinculado a sua conta",
  received_code: "Informe o código recebido",
  not_received: "Não recebeu o código?",
  click_here: "Clique aqui para reenviar",
  email_sent: "E-mail enviado, aguarde",
  to_try_again: "para tentar novamente",
  report_new_password: "Informe e confirme sua nova senha",
  error_password: "As senhas não correspondem",
  check_password_inputs: "Verifique as senhas e tente novamente",
  password_reset: "Senha redefinida",
  your_password_reset: "Sua senha foi redefinida com sucesso",
};
